// extracted by mini-css-extract-plugin
export var statItem = "_dl-1";
export var statsRow = "_dl-0";